import React from 'react'
import { CustomField } from './styles'

export default function FormInput ({ field, form, $disabled, ...props }) {
  return <CustomField {...field} {...props} disabled={$disabled} />
}
